import React from 'react'
import Image from 'next/image'
import { Box, Link, SxProps, Theme } from '@mui/material'

interface VatBadgeProps {
    size?: number
    sx?: SxProps<Theme>
}

const VAT_CERT_URL = 'https://ui.cltp.co/flyin-static/docs/flyin-VAT-cert.pdf'
const VAT_IMAGE_URL = 'https://ui.cltp.co/flyin-static/img/vat-cert-logo.png'

/**
 * Reusable VAT badge used across all footers.
 */
export const VatBadge: React.FC<VatBadgeProps> = ({ size = 32, sx }) => (
    <Link href={VAT_CERT_URL} target="_blank" aria-label="VAT certificate">
        <Box sx={{ width: size, height: size, display: 'inline-flex', ...sx }}>
            <Image
                src={VAT_IMAGE_URL}
                alt="VAT certificate"
                width={size}
                height={size}
                style={{ width: '100%', height: '100%' }}
                loading="lazy"
                priority={false}
                unoptimized
            />
        </Box>
    </Link>
)

export default VatBadge
